export const TabLogin = "login"
export const TabCreateAccount = "create_account"

export type Tab = typeof TabLogin | typeof TabCreateAccount
